import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "questionnaire-header";

const keys = addTranslations(RESOURCE_NAME, {
    subtitle_created_by: {
        en: "Created by: ",
        fr: "Créé par: ",
    },
    subtitle_requested_by: {
        en: "Requested by: ",
        fr: "Demandé par: ",
    },
    edit: {
        en: "Edit",
        fr: "Modifier",
    },
});

export const useQuestionnaireHeaderTranslations = () => {
    const { t } = useTranslation(RESOURCE_NAME);

    return { t, keys };
};
